import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";
import { CommonFunctions } from "../static/common-functions";

 export class v_QuoteNoteBus extends BaseBus
 { 
     constructor(busObj: BaseBus = null) {
         super(busObj);
         if (CommonFunctions.hasValue(this.insertDt)) {
             this.insertDt = new Date(this.insertDt);
         }
         if (CommonFunctions.hasValue(this.updateDt)) {
             this.updateDt = new Date(this.updateDt);
         }
         this.isDraged = false;
     }
    
     CID(): any {
         return this.quoteNoteId;
     }
     setId(id: any) {
         this.quoteNoteId = id;
     }
     setParentId(id: any) {
         this.quoteId = id;
     }
     setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
         if (!DateFunctions.isValidDate(this.insertDt)) {
             this.insertDt = date;
             this.insertUserId = userId;
         }
         this.updateDt = date;
         this.updateUserId = userId;
     }
     setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
         this.quoteNotePersonId = personId;
     }

     quoteNoteId: string;
    quoteNotes: string;
    isPrintable: boolean;
    sortOrder: number;
    personName: string;
    insertUserName: string;
    updateUserName: string;
    quoteId: string;
    quoteNotePersonId: string;
    insertDt: Date;
    insertUserId: string;
    updateDt: Date;
     updateUserId: string;
     isDraged: boolean;
 }
